/** Bank of Israel identification-code list, updated 12 July 2026. */
export const ISRAELI_BANKS = [
  { code: '03', name: 'בנק אש ישראל' },
  { code: '04', name: 'בנק יהב' },
  { code: '09', name: 'דואר פיננסים (בנק הדואר)' },
  { code: '10', name: 'בנק לאומי' },
  { code: '11', name: 'בנק דיסקונט' },
  { code: '12', name: 'בנק הפועלים' },
  { code: '13', name: 'בנק אגוד' },
  { code: '14', name: 'בנק אוצר החייל' },
  { code: '17', name: 'בנק מרכנתיל דיסקונט' },
  { code: '18', name: 'וואן זירו הבנק הדיגיטלי' },
  { code: '20', name: 'בנק מזרחי־טפחות' },
  { code: '22', name: 'סיטיבנק' },
  { code: '23', name: 'HSBC' },
  { code: '25', name: 'BNP Paribas' },
  { code: '26', name: 'יובנק' },
  { code: '31', name: 'הבנק הבינלאומי' },
  { code: '34', name: 'בנק ערבי ישראלי' },
  { code: '37', name: 'בנק אלאורדון' },
  { code: '38', name: "הבנק המסחרי הפלסטיני (אל־תיג'ארי)" },
  { code: '39', name: 'State Bank of India' },
  { code: '43', name: 'Jordan Ahli Bank' },
  { code: '46', name: 'בנק מסד' },
  { code: '49', name: 'Arab Bank' },
  { code: '52', name: 'בנק פועלי אגודת ישראל (פאג״י)' },
  { code: '54', name: 'בנק ירושלים' },
  { code: '66', name: 'Cairo Amman Bank' },
  { code: '67', name: 'Arab Land Bank' },
  { code: '68', name: 'בנק מוניציפל' },
  { code: '71', name: 'Jordan Gulf Bank' },
  { code: '73', name: 'Arab Islamic Bank' },
  { code: '76', name: 'Palestine Investment Bank' },
  { code: '82', name: 'Al-Quds Bank' },
  { code: '84', name: 'The Housing Bank' },
  { code: '89', name: 'Bank of Palestine' },
  { code: '93', name: 'Jordan Kuwait Bank' },
  { code: '99', name: 'בנק ישראל' },
] as const;

export const bankOptionLabel = (bank: (typeof ISRAELI_BANKS)[number]) =>
  `${bank.code} — ${bank.name}`;
